import * as React from 'react';
import { SignupState } from '../admin/signup.types';
import { AuthState } from '../auth/auth.types';
import { ADMIN } from '../account/Constants';
import AuthFooter from '../auth/auth-footer.component';
import { AdminState } from '../admin/admin.types';

interface Props {
  authState: AuthState;
  toDashboard: () => void;
  toAdminDashboard: () => void;
  signupState: SignupState;
  adminState: AdminState;
}

interface States {

}

class NotFoundComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const { authState, signupState, adminState } = this.props;

    return(
      <div className="container animated fadeIn">
        <div className="row">
            <div className="col-md-12">
              <div
                style={{
                  paddingTop: 40,
                  paddingRight: 15,
                  textAlign: 'center'
                }}
              >
                <h1>404 Not Found</h1>
                <h2>Sorry, Requested page not found!</h2>
                <div
                  className="error-actions"
                  style={{
                    marginTop: 15,
                    marginBottom: 15
                  }}
                >
                    <a
                      href=""
                      className="btn btn-primary btn-lg"
                      onClick={(event) => this.selectDashboard(authState, signupState, adminState)}
                    >
                      <span className="glyphicon glyphicon-home" /> Take Me To Dashboard 
                    </a>
                </div>
              </div>
            </div>
        </div>
        <div
          style={{
            textAlign: 'center'
          }}
        >
          <AuthFooter/>
        </div>
      </div>
    );
  }

  private selectDashboard = (authState: AuthState, signupState: SignupState, adminState: AdminState): void => {
    const { toDashboard, toAdminDashboard } = this.props;

    if (
      authState.account &&
      authState.account.accountType === ADMIN &&
      adminState.impersonation &&
      adminState.impersonation.account && 
      adminState.impersonation.account.id === 0
    ) {
      toAdminDashboard();
    } else {
      toDashboard();
    }
  }
}

export default NotFoundComponent;



// WEBPACK FOOTER //
// ./src/commons/not.found.component.tsx